import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { AgentSidebar } from '../agent-sidebar/agent-sidebar';
import { HeaderComponent } from '../header/header.component';
import { LoaderComponent } from '../loader/loader.component';
@Component({
  selector: 'app-content-layout',
  imports: [RouterOutlet, AgentSidebar, LoaderComponent, HeaderComponent, AgentSidebar],
  templateUrl: './content-layout.html',
  styleUrl: './content-layout.scss',
})
export class ContentLayout {
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly viewportScroller: ViewportScroller) {}
  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
